import { Checkbox as CheckboxPrimitive } from 'radix-ui';
import type { ComponentProps } from 'react';

export const Checkbox = CheckboxPrimitive.Root;
export const CheckboxIndicator = CheckboxPrimitive.Indicator;

export type CheckboxProps = ComponentProps<typeof CheckboxPrimitive.Root>;
export type CheckboxIndicatorProps = ComponentProps<typeof CheckboxPrimitive.Indicator>;
/** `indeterminate` is a third state, not a flavour of unchecked. */
export type CheckboxCheckedState = CheckboxProps['checked'];
